import React, { Component } from 'react';
import { Redirect } from 'react-router';
import ChatBot from 'react-simple-chatbot';
import { ThemeProvider } from 'styled-components';
import questions from '../constants/questionList';
import Header from '../css/Header';
import HeaderTitle from '../css/HeaderTitle';
import UseStore from '../store/store';
import Loading from './loading'


const theme = {
  background: '#f5f8fb',
  fontFamily: 'Helvetica Neue',
  headerBgColor: '#428bca',
  headerFontColor: '#fff',
  headerFontSize: '15px',
  botBubbleColor: '#428bca',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
  borderRadius: '40px',
};

export default function SimpleForm(){
  const { mpUser } = UseStore()

  if(mpUser === null){
    return <Redirect to="/401" />
  }
  else {
    return (
      <ThemeProvider theme={theme}>
        <ChatBot
          steps={questions(mpUser.userDetails, mpUser.age)}
          style = { 
            { width: '100vw',height: '100vh' }
           }
          contentStyle = { { height: '85%' } }
          hideBotAvatar={ true }
          headerComponent={
            <Header className="rsc-header">
              {/* <img alt="ICICI" src="https://hra-react.s3.ap-south-1.amazonaws.com/public/img/logo193.png" style={{ width: "10%", float: "left" }} /> */}
              <HeaderTitle className="rsc-header-title"><br />HEALTH RISK ASSESSMENT</HeaderTitle>
            </Header>
          }
          hideUserAvatar={true}
          footerStyle = { { position: 'relative', bottom: '0px', width: '100vw' } }
        />
      </ThemeProvider>
    );
  }
}